import { LoadingButton } from "@mui/lab";
import { LinearProgress, Tab } from "@mui/material";
import classNames from "classnames";
import { JSXElementConstructor, useEffect, useMemo, useState } from "react";
import { configsApi } from "../../../http";
import EximWebsiteSettings from "./EximWebsiteSettings";

const TABS: {
  key: string;
  label: string;
  component: JSXElementConstructor<any>;
}[] = [
  {
    key: "eximWebsiteBanner",
    label: "Exim Website",
    component: EximWebsiteSettings,
  },
];

export default function BlockchainSettings() {
  const [tab, setTab] = useState<(typeof TABS)[number]>(TABS[0]);
  const [value, setValue] = useState();
  const [tempValue, setTempValue] = useState();
  const [isGetValuePending, setIsGetValuePending] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const SettingsComponent = tab.component;

  const isDirty = useMemo(
    () => JSON.stringify(tempValue || {}) !== JSON.stringify(value || {}),
    [value, tempValue]
  );

  const getValue = async () => {
    try {
      setIsGetValuePending(true);
      const value = await configsApi.getBlockchainConfig(tab.key);
      setValue(value);
      setTempValue(value);
    } finally {
      setIsGetValuePending(false);
    }
  };

  const saveValue = async () => {
    try {
      setIsSaving(true);
      await configsApi.updateBlockchainConfigs(tab.key, tempValue);
      setValue(tempValue);
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    getValue();
  }, [tab]);

  return (
    <div className="h-full flex pt-4">
      {isGetValuePending && (
        <LinearProgress className="absolute top-[46px] left-[164px] right-0" />
      )}

      {isDirty && (
        <LoadingButton
          className="absolute right-0 top-0"
          variant="contained"
          color="secondary"
          loading={isSaving}
          onClick={saveValue}
        >
          Save Changes
        </LoadingButton>
      )}

      <div className="flex h-full flex-col w-[200px] border-r border-gray-300">
        {TABS.map((t) => (
          <Tab
            key={t.key}
            className={classNames("px-2", {
              "bg-secondary text-white": t.key === tab.key,
            })}
            label={t.label}
            onClick={() => setTab(t)}
          />
        ))}
      </div>

      <div className="w-full px-4">
        <SettingsComponent value={tempValue} onChange={setTempValue} />
      </div>
    </div>
  );
}
